import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["inherited", "field"];

  declare inheritedTarget: HTMLElement;
  declare fieldTarget: HTMLElement;

  showField(): void {
    this.inheritedTarget.classList.add("is-hidden");
    this.fieldTarget.classList.remove("is-hidden");
  }
}
